// as design data follow the SVG specification we arranged rates to make the condition
// `value * fontSize` works on preflight without additional conversions
import limitPrecision from 'editor/src/util/limitPrecision';

export const MIN_TEXT_OUTLINE_WIDTH = 0.1;
export const MAX_TEXT_OUTLINE_WIDTH = 20;
export const CANVAS_TO_SVG_STROKE = 170;

export const calculateSVGStrokeWidth = (width: number) => limitPrecision(width / CANVAS_TO_SVG_STROKE);
